import {
  contactMatches,
  formatPhone,
  primaryPhone,
  type Contact,
  type Job,
} from "@roof-hawk/core";

/**
 * Finding a customer from the phone (ADR 0321).
 *
 * Jonathon, 2026-10-27: the phone must let you pick "which customer you're
 * texting or calling". Typing a name or a number in the box at the top lists
 * the customers it matches, and tapping one opens their conversation, or
 * starts one, so a customer nobody has texted yet can be texted from here.
 */

/**
 * Customers matching what was typed, first ten: the Contacts search's own
 * rule, so a name, a company, an address, an email or a number all find them.
 */
export function findContacts(
  contacts: readonly Contact[],
  typed: string,
): Contact[] {
  const query = typed.trim();
  if (!query) return [];
  return contacts.filter((c) => contactMatches(c, query)).slice(0, 10);
}

export function ContactHits({
  hits,
  jobs,
  typed,
  onPick,
}: {
  hits: Contact[];
  jobs: Job[];
  typed: string;
  onPick: (contact: Contact) => void;
}) {
  if (hits.length === 0)
    return (
      <div className="msg-empty">
        Nobody called “{typed.trim()}”. Add them with + New Lead.
      </div>
    );
  return (
    <div className="list" role="list" aria-label="Customers">
      {hits.map((contact) => {
        const count = jobs.filter((j) => j.contact_id === contact.id).length;
        return (
          <button
            key={contact.id}
            type="button"
            role="listitem"
            className="msg-row"
            onClick={() => onPick(contact)}
          >
            <span className="msg-top">
              <span className="msg-name">{contact.full_name ?? "—"}</span>
            </span>
            <span className="msg-text">
              {formatPhone(primaryPhone(contact)) ?? "No number"}
              {count ? ` · ${count} ${count === 1 ? "job" : "jobs"}` : ""}
            </span>
          </button>
        );
      })}
    </div>
  );
}
